module.exports = __webpack_public_path__ + "pc/img/magazine02.3066f1a4.jpg";